// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__GAdD1","info":"UpdateTermsInfo_info__2KrKN"};